<template>
  <v-list-item
    class="cat-form"
    :class="(form.id ? 'edit-cat' : 'add-cat')"
    @click.stop
  >
      <v-list-item-icon>
        <v-radio-group v-model="mode" column>
          <v-radio
            :value="parseInt(form.id)"
            :color="(!$vuetify.theme.dark ? 'grey darken-2' : 'white')"
            :off-icon="(form.id ? 'mdi-playlist-edit' : 'mdi-plus-thick')"
            :on-icon="(form.id ? 'mdi-playlist-edit' : 'mdi-plus-thick')"
            class="radio-type"
            light
            readonly
          ></v-radio>
        </v-radio-group>
        <!-- <v-icon :color="(form.id ? 'amber' : 'green')">{{ (form.id ? 'mdi-playlist-edit' : 'mdi-plus-thick') }}</v-icon> -->
      </v-list-item-icon>
      <v-list-item-content>
        <v-form
          ref="saveForm"
          v-model="valid"
          lazy-validation
          :disabled="get_interface.loading"
        >
          <v-list-item-title>
            <v-content fluid class="form-content">
              <v-subheader>
                {{ (form.id > 0 ? lang.categories.edit.title : lang.categories.new.title) }}
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click.stop="$emit('closed')"
                      icon
                      medium
                      class="closeBtn"
                      color="gray darken-2"
                    >
                      <v-icon
                        medium
                      >mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.categories.new.close }}</span>
                </v-tooltip>
              </v-subheader>
              <v-row class="form-row">
                <v-col cols="12">
                  <v-text-field
                    :label="lang.categories.new.name"
                    v-model="form.name"
                    :rules="lang.categories.new.rules.nameRules"
                    :loading="get_interface.loading"
                    :disabled="get_interface.loading"
                    autocomplete="new-password"
                    filled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="form-row">
                <v-col cols="12">
                  <v-select
                    :label="lang.categories.new.parent"
                    :no-data-text="lang.categories.new.no_parent"
                    v-model="form.parent"
                    :items="Object.values(get_data.categories).filter(cat_ => cat_.parent === 0 && (cat_.id !== form.id && cat_.catalog === form.catalog))"
                    :loading="get_interface.loading"
                    :disabled="(get_interface.loading || (form.id > 0 && (typeof form.children !== 'undefined' && Object.keys(form.children).length > 0 || form.children.length > 0)))"
                    item-text="name"
                    item-value="id"
                    filled
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="actions-row">
                <v-col cols="12" class="px-0 mx-0">
                  <p v-if="(form.id > 0 && (typeof form.children !== 'undefined' && Object.keys(form.children).length > 0 || form.children.length > 0))" class="parent-alert">{{ lang.categories.edit.parentAlert }}</p>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        medium
                        @click.stop="saveCat(form)"
                        :disabled="get_interface.loading"
                        class="mr-2"
                        color="gray darken-2"
                      >
                        <v-icon medium color="green">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ lang.categories.new.save }}</span>
                  </v-tooltip>
                  <v-tooltip left v-if="form.id === 0">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        medium
                        @click.stop="clearForm()"
                        :disabled="get_interface.loading"
                        color="gray darken-2"
                      >
                        <v-icon medium color="blue">mdi-broom</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ lang.categories.new.clear }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-content>
          </v-list-item-title>
        </v-form>
      </v-list-item-content>
  </v-list-item>
</template>

<script>
import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'

export default {
  mixins: [ appdata, save ],
  props: {
    catalog: {
      type: String,
      required: true
    },
    cat: {
      type: Object,
      required: false,
      default: function () {
        return { ...defaults.blank.category(this.catalog) }
      }
    }
  },
  data () {
    return {
      valid: false,
      form: { ...this.cat } || {}
    }
  },
  computed: {
    mode () {
      return parseInt(this.cat.id)
    }
  },
  watch: {
    cat: {
      deep: true,
      handler (newVal) {
        this.form = { ...newVal }
      }
    }
  },
  methods: {
    clearForm () {
      this.$refs.saveForm.reset()
    },
    saveCat (cat) {
      if (cat && this.$refs.saveForm.validate()) {
        this.$store.dispatch('saveData', { page: 3, data: cat, item: cat.id })
      }
    }
  }
}
</script>
